import { render } from "./GemMechanism09Lose.vue?vue&type=template&id=fce2568e"
import script from "./GemMechanism09Lose.vue?vue&type=script&lang=js"
export * from "./GemMechanism09Lose.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__